import { render, staticRenderFns } from "./Container4.vue?vue&type=template&id=10bc09b3&scoped=true"
import script from "./Container4.vue?vue&type=script&lang=js"
export * from "./Container4.vue?vue&type=script&lang=js"
import style0 from "./Container4.vue?vue&type=style&index=0&id=10bc09b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc09b3",
  null
  
)

export default component.exports